module.exports = {"130421100":"尚璧镇","130421102":"河沙镇镇","130421200":"南堡乡","130421201":"南吕固乡","130421202":"兼庄乡","130421203":"代召乡","130421212":"姚寨乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130421.json
// module id = 103
// module chunks = 0